// extracted by mini-css-extract-plugin
export default {"operateWrap":"index_operateWrap__T2pVt"};